<template>
  <div class="customContainer">
    <div class="title">Formas de pagamentos</div>

    <div class="customRow">
      <div style="flex: 1 1 200px; min-width: 200px">
        <InputSelect
          label="Forma de pagamento"
          valueField="value"
          textField="text"
          :items="typePaymentsForCombobox"
          :dataSelect.sync="payload.cod"
          :enableIconCreate="false"
          ref="cod"
        />
      </div>

      <div style="flex: 1 1 auto; min-width: 200px">
        <Input
          label="Descrição"
          :labelFixed="true"
          :dataInput.sync="payload.nome"
          ref="nome"
        />
      </div>

      <div style="flex: 1 1 50px; min-width: 200px">
        <InputSelect
          label="Bandeira"
          valueField="value"
          textField="text"
          :items="flags"
          :dataSelect.sync="payload.bandeira"
          :dataInput="payload.bandeira"
          :enableIconCreate="false"
          ref="bandeira"
        />
      </div>

      <div style="flex: 1 1 auto; max-width: 100px; min-width: 100px">
        <InputMoney
          v-if="!typeTaxChecked"
          label="Taxa"
          :labelFixed="true"
          type="text"
          :dataInput.sync="payload.taxa"
          ref="taxa"
        />

        <InputPercentage
          v-else
          label="Taxa"
          :labelFixed="true"
          type="text"
          :dataInput.sync="payload.taxa"
          ref="taxa"
        />
      </div>

      <div style="flex: 1 1 auto; max-width: 100px; min-width: 100px">
        <InputSelect
          label="Assumir taxa ?"
          textField="text"
          valueField="value"
          :items="bearTheFeeItems"
          :dataSelect.sync="payload.assumirTaxa"
          :enableIconCreate="false"
          :dataInput="payload.assumirTaxa"
          ref="assumirTaxa"
        />
      </div>

      <div style="flex: 1 1 auto; max-width: 50px">
        <label class="switch">
          <input
            type="checkbox"
            ref="typeDiscount"
            v-model="typeTaxChecked"
            @change="handleChangeTypeTax"
          />
          <div class="slider">
            <span style="margin-top: 2px">R$</span>
            <span style="margin-top: 2px">%</span>
          </div>
        </label>
      </div>
    </div>

    <div class="contentActionsBtn">
      <button
        class="btnPayment btnAdd"
        style="display: flex; justify-content: center; align-items: center"
        @click="saveOrUpdate"
      >
        <b-spinner
          v-if="loadingToAdd"
          style="width: 20px; height: 20px; color: white"
        />

        <p style="margin: 0" v-else>Adicionar</p>
      </button>

      <button class="btnPayment btnCancelEdit" @click="clear">
        <b-icon-plus scale="2" class="icon" />
      </button>
    </div>

    <div
      class="title"
      style="font-size: 13px; border: none; color: black; margin: 0 0 0.5rem 0"
    >
      Métodos de Pagamento Cadastrados
    </div>

    <div
      style="
        width: 100%;
        overflow: auto;
        border-radius: 5px;
        border: 1px solid #d5d3d3;
        max-height: 300px;
      "
    >
      <table>
        <thead>
          <tr>
            <th>Descrição</th>
            <th>Método</th>
            <th>Bandeira</th>
            <th style="text-align: center">Assumir</th>
            <th>Taxa</th>
            <th style="text-align: end">Ações</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="payment of listPaymentsMethods" :key="payment.id">
            <td>{{ payment.nome || "Não informado" }}</td>

            <td>
              <div style="display: flex; align-items: center; gap: 0.8rem">
                <div
                  style="
                    padding: 0.3rem 0.5rem;
                    background-color: #dee7ff;
                    padding: 7px;
                    border-radius: 50px;
                  "
                >
                  <p style="line-height: 1; font-size: 11px">
                    {{ payment.tipo }}
                  </p>
                </div>
              </div>
            </td>

            <td>
              {{ getFlagText(payment.bandeira) }}
            </td>

            <td style="text-align: center">
              {{ payment.assumirTaxa === 1 ? "Sim" : "Não" }}
            </td>

            <td style="color: green; font-size: 14px">
              {{
                payment.tipoTaxa === "monetario"
                  ? `R$ ${payment.taxa || "0.00"}`
                  : `% ${payment.taxa || "0.00"}`
              }}
            </td>

            <td
              style="
                width: 100%;
                display: flex;
                justify-content: flex-end;
                align-items: center;
                gap: 0.3rem;
              "
            >
              <div
                class="contentActions"
                @click="deletePayment(payment.id)"
                :style="
                  payloadToDelete.isLoading &&
                  'pointer-events: none; background-color: rgb(233 233 233)'
                "
              >
                <b-spinner
                  v-if="
                    payloadToDelete.isLoading &&
                    payloadToDelete.id === payment.id
                  "
                  class="spin"
                />

                <b-icon-trash v-else style="color: brown" scale="1.3" />
              </div>

              <div class="contentActions" @click="edit(payment)">
                <b-icon-pen style="color: rgb(88 128 255)" scale="1.3" />
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import InputSelect from "../UI/CustomInputs/InputSelect.vue";
import Input from "../UI/CustomInputs/Input.vue";
import InputMoney from "../UI/CustomInputs/InputMoney.vue";
import InputPercentage from "../UI/CustomInputs/InputPercentage.vue";

import ServicePaymentForm from "../../services/servicePaymentForm";

import { ValidadePaymentMethods } from "../../validators/paymentMethods";
import { TypePaymentsForCombobox } from "../../common/index";
import { removeReference } from "../../utils/removeReference";
import { HandleErrors } from "../../utils/handleErrors";

export default {
  components: {
    InputSelect,
    Input,
    InputMoney,
    InputPercentage,
  },
  data() {
    return {
      typePaymentsForCombobox: TypePaymentsForCombobox,
      payload: {
        id: null,
        tipo: null,
        cod: null,
        nome: null,
        taxa: null,
        tipoTaxa: "monetario",
        assumirTaxa: true,
        bandeira: null,
      },
      typeTaxChecked: false,
      loadingToAdd: false,
      bearTheFeeItems: [
        { text: "Sim", value: true },
        { text: "Não", value: false },
      ],
      listPaymentsMethods: [],
      flags: [
        { text: "Selecione...", value: null },
        { text: "Visa", value: "visa" },
        { text: "Mastercard", value: "mastercard" },
        { text: "American Express", value: "american_express" },
        { text: "Discover", value: "discover" },
        {
          text: "Diners Club International",
          value: "diners_club_international",
        },
        { text: "JCB", value: "jcb" },
        { text: "UnionPay", value: "unionpay" },
        { text: "Elo", value: "elo" },
        { text: "Hipercard", value: "hipercard" },
        { text: "Aura", value: "aura" },
        { text: "Sorocred", value: "sorocred" },
        { text: "Cabal", value: "cabal" },
      ],
      payloadToDelete: {
        id: null,
        isLoading: false,
      },
    };
  },
  methods: {
    async saveOrUpdate() {
      if (!this.isValid()) return;

      this.payload.id ? await this.update() : await this.create();

      await this.list();
      this.clear();

      this.$emit("listPaymentMethods");
    },
    async create() {
      try {
        this.loadingToAdd = true;
        const id = await ServicePaymentForm.save(this.payload);
        this.payload.id = id;

        this.$toast.open({
          message: "Novo tipo de pagamento registrado!",
          type: "success",
        });
      } catch (error) {
        const typeError = HandleErrors(
          error?.response?.data?.message === "Validation failed"
            ? error?.response?.data?.erros
            : error?.response?.data?.message
        );

        this.$toast.open({
          message:
            typeError.message ||
            "Ocorreu um problema ao cadastrar um novo tipo de pagamento.",
          type: "info",
        });
      } finally {
        this.loadingToAdd = false;
      }
    },
    async update() {
      try {
        this.loadingToAdd = true;
        await ServicePaymentForm.update(this.payload.id, {
          ...this.payload,
          assumirTaxa: Boolean(this.payload.assumirTaxa),
        });

        this.$toast.open({
          message: "Tipo de pagamento atualizado!",
          type: "success",
        });
      } catch (error) {
        const typeError = HandleErrors(
          error?.response?.data?.message === "Validation failed"
            ? error?.response?.data?.erros
            : error?.response?.data?.message
        );

        this.$toast.open({
          message:
            typeError.message ||
            "Ocorreu um problema ao atualizar um novo tipo de pagamento.",
          type: "info",
        });
      } finally {
        this.loadingToAdd = false;
      }
    },
    async list() {
      this.listPaymentsMethods = await ServicePaymentForm.getAllPayment();
    },
    async deletePayment(id) {
      try {
        this.payloadToDelete = {
          id,
          isLoading: true,
        };
        await ServicePaymentForm.deletePayment(id);

        this.$toast.open({
          message: "Forma de pagamento removida!",
          type: "success",
        });

        await this.list();

        this.$emit("listPaymentMethods");
      } catch (error) {
        this.$toast.open({
          message:
            error?.response?.data?.message ||
            "Ocorreu um problema ao remover esta forma de pagamento!",
          type: "info",
        });
      } finally {
        this.payloadToDelete = {
          id: null,
          isLoading: false,
        };
      }
    },
    edit(payment) {
      this.handleAssing(removeReference(payment));
    },
    clear() {
      this.payload = {
        id: null,
        tipo: null,
        cod: null,
        nome: null,
        taxa: null,
        tipoTaxa: "monetario",
        assumirTaxa: true,
        bandeira: null,
      };

      this.$refs.nome.valueInput = null;
      this.$refs.cod.valueItems = null;
      this.$refs.assumirTaxa.valueItems = true;
      this.$refs.bandeira.valueItems = null;
      this.$refs.taxa.valueInput = null;

      this.typeTaxChecked = false;
    },
    isValid() {
      const result = ValidadePaymentMethods({
        ...this.payload,
        assumirTaxa: Boolean(this.payload.assumirTaxa),
      });

      if (result && Object.keys(result).length) {
        this.$toast.open({
          message: result.message,
          type: "info",
        });

        return false;
      }

      return true;
    },
    handleChangeTypeTax() {
      this.payload.tipoTaxa = this.typeTaxChecked ? "porcentagem" : "monetario";
    },
    handleAssing(payment) {
      this.payload = payment;

      this.$refs.nome.valueInput = payment.nome;
      this.$refs.cod.valueItems = payment.cod;
      this.$refs.bandeira.valueItems = payment.bandeira;
      this.$refs.assumirTaxa.valueItems =
        payment.assumirTaxa === 1 ? true : false;
      this.$refs.taxa.valueInput = payment.taxa;

      this.typeTaxChecked = payment.tipoTaxa === "monetario" ? false : true;
    },
    getFlagText(item) {
      if (item) return this.flags.find((flag) => flag.value === item)?.text;

      return "Não informada";
    },
  },
  mounted() {
    this.list();
  },
};
</script>

<style scoped>
.title {
  font-size: 16px;
  color: rgb(95, 95, 95);
  display: flex;
  margin-bottom: 20px;
  margin-right: 20px;
  border-bottom: 1px solid rgb(230, 230, 230);
  justify-content: space-between;
}

.customContainer {
  display: flex;
  flex-direction: column;
}

.customRow {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
}

/* The slider */

.switch {
  height: 30px;
  margin: 0;
  font-size: 14px;
  position: relative;
  display: inline-block;
}

.slider {
  cursor: pointer;
  background-color: #d9d9d9;
  color: #ffffff;
  border-radius: 50px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  transition: 0.4s;
  width: 50px !important;
  height: 90%;
  font-size: 8px;
}

.slider:before {
  position: absolute;
  content: "R$";
  font-size: 10px;
  height: 70%;
  width: 23px;
  left: 6%;
  border-radius: 50px;
  background-color: #00aa62;
  color: white;
  display: grid;
  align-content: center;
  justify-content: center;
  transition: 0.4s;
  font-weight: bold;
}

.slider:after {
  content: "";
  position: absolute;
  z-index: -1;
}

.switch input:checked + .slider {
  background-color: #d9d9d9;
  color: white;
}

.switch input:checked + .slider:before {
  content: "%";
  background-color: #00aa62;
  transform: translateX(85%);
  color: white;
}

.switch input {
  display: none;
}

table {
  width: 100%;
}

th,
td {
  font-size: 12px;
  font-weight: 500 !important;
}

th {
  padding: 0 0.5rem;
  height: 40px;
}

td {
  padding: 0.5rem;
}

thead {
  background-color: rgba(201, 201, 201, 0.177);
}

.spin {
  color: red;
  width: 18px;
  height: 18px;
}

.contentActionsBtn {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.5rem;
  margin-top: 1.5rem;
}

.btnPayment {
  height: 28px;
  border-radius: 5px;
  background-color: transparent;
  width: 115px;
  border: none;
  border: solid 1px black;
  color: black;
  font-size: 12px;
}

.btnAdd {
  width: 80px;
  background-color: #0fbf4d;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.325);
  color: white;
  border: none;
}

.btnCancelEdit {
  width: 30px;
  background-color: brown;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.325);
  color: white;
  border: none;
}

p {
  margin: 0;
}

.contentActions {
  height: 25px;
  width: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  cursor: pointer;
  transition: ease-in all 0.1s;
  border: solid 1px #c0c0c0;
  background-color: white;
}

.contentActions:hover {
  background-color: #ededed;
}
</style>